import { HTMLAttributes, PropsWithChildren } from "react";

const RoleBasedAssessmentQuestionLayout = ({
  children,
  ...htmlProps
}: PropsWithChildren<Pick<HTMLAttributes<HTMLDivElement>, "aria-label">>) => {
  return (
    <div className="border rounded-lg" {...htmlProps}>
      {children}
    </div>
  );
};

const Container = ({ children }: PropsWithChildren) => {
  return <div className="mt-12 first:mt-0">{children}</div>;
};

RoleBasedAssessmentQuestionLayout.Container = Container;

export default RoleBasedAssessmentQuestionLayout;
